module.exports = __webpack_public_path__ + "img/QRCode4.47cfa688.png";